import React from 'react';
import { Chip as MChip } from 'phoenix-components';
import PropTypes from 'prop-types';
import { isEmpty } from 'ui/lodash';
import styles from './Chip.module.css';

function Chip({
  items,
  selected,
  chipStyles,
  onSelect,
}) {

  const diff = items.filter(item => !selected.some(other => item.value === other.value));
  const swapped = selected.concat(diff);

  const handleChange = (isSelected, value) => {

    if (isSelected) {

      const list = selected.concat(value);
      onSelect(list);

    } else {

      const list = selected.filter(x => x.value !== value.value);
      onSelect(list);

    }

  };

  const isSelected = (item) => {

    const res = selected.find(x => x.value === item.value);
    return !isEmpty(res);

  };

  return (
    <div className={chipStyles}>
      <div className={styles.container}>
        <div className={styles.list}>
          {swapped?.map((x, i) => (
            <MChip
              key={i}
              label={x?.label}
              selected={isSelected(x)}
              className={styles.chip}
              onSelect={() => handleChange(!isSelected(x), x)}
            />
          ))}
        </div>
      </div>
    </div>
  );

}

Chip.propTypes = {
  items: PropTypes.array.isRequired,
  chipStyles: PropTypes.any.isRequired,
  onSelect: PropTypes.func.isRequired,
  selected: PropTypes.array.isRequired,
};

export default Chip;
